import { FunctionComponent, useContext, useState } from "react";
import Header from "@/components/Header";
import LocaleText from "@/components/Intl/LocaleText";
import Button from "@/components/Button";
import Styles from "./styles.module.scss";
import Inner from "@/components/Inner";
import { useNavigate } from "react-router-dom";
import ERoutes from "@/routers/AuthRouter/routes";
import { useGetAnimatorData } from "@/hooks/useGetAnimatorData";
import { AuthContext } from "@/providers/AuthProvider";
import { EUserRole } from "@/providers/AuthProvider/interfaces";
import PopinPdf from "@/components/PopinPdf";

const Animator: FunctionComponent = () => {
  const router = useNavigate();
  const { currentCampaignData, futureCampaignData, isLoading } =
    useGetAnimatorData();
  const [pdfPopinAccessibility, setPdfPopinAccessibility] =
    useState<boolean>(false);

  const auth = useContext(AuthContext);
  const { user } = auth;

  const isAnimator = user?.roles.includes(EUserRole.ANIMATOR);

  if (isLoading) {
    return <div>Chargement...</div>;
  }
  return (
    <div className={Styles["animator__mainContainer"]}>
      <Header hideDisconnect={false} />
      <Inner className={Styles["animator__body"]}>
        <div>
          <div className={Styles["animator__title"]}>
            <LocaleText>page.animator.title</LocaleText>
          </div>
          {isAnimator && (
            <Button
              outline={true}
              className={Styles["animator__campaign-button"]}
              onClick={() => router(ERoutes.AnimatorNewCampaign)}
            >
              <LocaleText>page.animator.new.title</LocaleText>
            </Button>
          )}
          <div className={Styles["animator__horizontalLine"]}></div>
          <div className={Styles["animator__campaign-list"]}>
            <div className={Styles["animator__section"]}>
              <LocaleText>page.animator.current</LocaleText>
            </div>
            {currentCampaignData.length > 0 ? (
              currentCampaignData.map((campaign) => (
                <Button
                  key={campaign.token}
                  onClick={() =>
                    router(ERoutes.ProcessAI + "?campaign=" + campaign.token)
                  }
                  outline={true}
                  className={Styles["animator__campaign-button"]}
                >
                  {campaign.name}
                </Button>
              ))
            ) : (
              <div className={Styles.animator__noCampaign}>
                <LocaleText>page.animator.none</LocaleText>
              </div>
            )}
            <div className={Styles["animator__section"]}>
              <LocaleText>page.animator.future</LocaleText>
            </div>
            {futureCampaignData.length > 0 ? (
              futureCampaignData.map((campaign) => (
                <Button
                  key={campaign.token}
                  outline={true}
                  className={`${Styles["animator__campaign-button"]} ${Styles["animator__future-campaign"]}`}
                >
                  {campaign.name}
                </Button>
              ))
            ) : (
              <div className={Styles.animator__noCampaign}>
                <LocaleText>page.animator.none</LocaleText>
              </div>
            )}
          </div>
        </div>
        <span
          className={Styles["animator__accessibility"]}
          onClick={() => setPdfPopinAccessibility(true)}
        >
          <LocaleText>page.animator.accessibility</LocaleText>
        </span>
      </Inner>
      <PopinPdf
        active={pdfPopinAccessibility}
        onClose={() => setPdfPopinAccessibility(false)}
        document={"Skinanalysia_Accessibilité-Numérique.pdf"}
      />
    </div>
  );
};

export default Animator;
